module.exports = __webpack_public_path__ + "static/img/11.da20fc1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/zh/11.png
// module id = Nb5g
// module chunks = 0